<template>
  <div>
    <div
      class="text-center"
      v-if="!dataLoaded"
    >
      <v-progress-circular
        class="mt-6"
        color="primary"
        indeterminate
        :size="50"
      />
    </div>

    <div v-show="dataLoaded">
      <v-row class="my-0 mt-4">
        <v-col
          cols="12"
          class="pt-0"
        >
          <v-card
            ref="mainCard"
            class="base-card pb-4 shadow"
          >
            <v-card-title class="mb-0 pb-0 d-flex justify-space-between">
              <h4>Кварталы</h4>

              <div class="d-inline-flex">
                <v-btn
                  class="ml-3 action-btn elevation-0 rounded-lg"
                  height="32"
                  :loading="generateLoading"
                  outlined
                  small
                  color="primary"
                  @click="generateNextYear"
                >
                  <v-icon class="uikit-icon plus primary size-20 mr-1" />
                  <span class="btn-text">Сгенерировать кварталы следующего года</span>
                </v-btn>
              </div>
            </v-card-title>

            <v-card-text
              class="my-0 py-0"
              :class="{
                'pr-4': !isVerticalScrollInTable,
                'pr-0': isVerticalScrollInTable
              }"
            >
              <v-data-table
                ref="table"
                class="base-table fixed-last-column shadow-for-last-column is-vertical-scroll elevation-0 mt-2"
                :class="{ 'shadow-last-column': isShadowForLastColumn }"
                hide-default-footer
                fixed-header
                loading-text="Загрузка"
                no-results-text="Отсутствуют результаты поиска"
                :loading="tableLoading"
                :headers="tableHeaders"
                group-by="year.id"
                :group-desc="true"
                :items="sortedPeriodListByQuarterNum"
                :items-per-page="-1"
              >
                <template v-slot:body.prepend="">
                  <div
                    v-if="!tableLoading"
                    style="height: 1px"
                  />
                </template>

                <template v-slot:item.index="{ index }">
                  {{ index + 1 }}
                </template>

                <template v-slot:item.isActual="{ item }">
                  {{ item.isActual === false ? 'нет' : item.isActual ? 'да' : '' }}
                </template>

                <template v-slot:group.header="{ group, toggle, isOpen }">
                  <td colspan="5">
                    <div
                      class="group-header"
                      @click="toggle"
                    >
                      <v-btn
                        :ref="closeGroupOnce(group, isOpen, toggle)"
                        class="mr-2"
                        icon
                        small
                        plain
                        :title="isOpen ? 'скрыть' : 'раскрыть'"
                      >
                        <v-icon
                          class="uikit-icon chevron-left-circle delay-03"
                          :class="isOpen ? 'rotate-90' : 'rotate-270'"
                        />
                      </v-btn>
                      <span>Кварталы {{ yearList.find(year => year.id === group)?.year || '' }} года</span>
                    </div>
                  </td>
                </template>

                <template v-slot:item.quarter="{ item }">
                  <div class="ml-4">
                    {{ quarterList.find(quarter => quarter.id === item.quarter.id)?.name || '' }}
                  </div>
                </template>

                <template v-slot:item.fromDate="{ item }">
                  {{ getFormatDate(item.fromDate) }}
                </template>

                <template v-slot:item.toDate="{ item }">
                  {{ getFormatDate(item.toDate) }}
                </template>

                <template v-slot:item.blockDate="{ item }">
                  {{ getFormatDate(item.blockDate) }}
                </template>

                <template v-slot:item.actions="{ item }">
                  <div class="table-icons">
                    <v-icon
                      class="uikit-icon edit-icon edit-btn"
                      title="Редактировать"
                      @click="edit(item)"
                    />
                  </div>
                </template>

                <template slot="no-data">
                  <div>Таблица пуста</div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <PeriodDialog
      :dialog="dialog"
      :saveBtnLoading="saveBtnLoading"
      :selectedItem="selectedItem"
      :isShowMode="isShowMode"
      @savePeriod="updatePeriod"
      @closeModal="closeDialog"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { isVerticalScrollInTable } from '@/mixins/isVerticalScrollInTable'
import { shadowForLastColumn } from '@/mixins/shadowForLastColumn'
import { tableHeight } from '@/mixins/tableHeight'
import { getFormatDate } from '../../scripts'
import PeriodDialog from '@/components/directories/period/dialogs/Period'
import { periodApi } from '@/api'
import { dictionaryNames } from '@/scripts/consts'

export default {
  name: 'PeriodParent',

  metaInfo: {
    title: 'Квартал'
  },

  components: {
    PeriodDialog
  },

  mixins: [shadowForLastColumn, tableHeight, isVerticalScrollInTable],

  created() {
    this.getPeriodParent()
  },

  data: () => ({
    filter: '',
    generateLoading: false,
    tableHeaders: [
      { text: 'Квартал', value: 'quarter', sortable: false, align: 'left' },
      { text: 'Дата начала', value: 'fromDate', sortable: false, align: 'center' },
      { text: 'Дата блокировки', value: 'blockDate', sortable: false, align: 'center' },
      { text: 'Дата окончания', value: 'toDate', sortable: false, align: 'center' },
      { text: 'Действия', value: 'actions', sortable: false, align: 'center', width: '80px' }
    ],

    tableLoading: false,
    selectedItem: null,
    confirmDialog: false,
    isShowMode: false,
    saveBtnLoading: false,
    removeLoading: false,
    dataLoaded: false,
    dialog: false,

    maxPeriodGroup: null,
    periodGroupCloseCheck: []
  }),

  computed: {
    ...mapGetters('dictionaries', ['periodList', 'yearList', 'quarterList']),

    sortedPeriodListByQuarterNum() {
      return [...this.periodList].sort((a, b) => b.quarter.quarterNum - a.quarter.quarterNum)
    }
  },

  methods: {
    getFormatDate,
    ...mapActions('dictionaries', ['getDictionaries', 'updateInDictionary', 'removeInDictionary']),
    ...mapMutations('dictionaries', ['clearDictionary', 'addInDictionary']),

    async getPeriodParent() {
      await this.getDictionaries([dictionaryNames.Period, dictionaryNames.Year, dictionaryNames.Quarter])
      this.maxPeriodGroup = this.getMaxPeriodGroup()
      this.dataLoaded = true
    },

    closeGroupOnce(group, isOpen, toggle) {
      if (
        this.maxPeriodGroup &&
        group !== this.maxPeriodGroup &&
        isOpen &&
        !this.periodGroupCloseCheck.includes(group)
      ) {
        toggle()
        this.periodGroupCloseCheck.push(group)
      }
    },

    getMaxPeriodGroup() {
      return this.periodList.length ? Math.max(...this.periodList.map(period => period.year.id)) : null
    },

    edit(item) {
      this.selectedItem = item
      this.dialog = true
    },

    closeDialog() {
      this.dialog = false
      this.selectedItem = null
      this.isShowMode = false
    },

    async generateNextYear() {
      try {
        this.resetPeriodGroupCloseParams()
        this.generateLoading = true
        const newPeriodList = await periodApi.generateNextYear()
        for (const period of newPeriodList) {
          this.addInDictionary({
            dictionaryType: dictionaryNames.Period,
            payload: period
          })
        }
        this.clearDictionary(dictionaryNames.Year)
        await this.getDictionaries([dictionaryNames.Year])
        this.maxPeriodGroup = this.getMaxPeriodGroup()
        this.$toast.info('Успешно сгенерировано')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка генерации')
      } finally {
        this.generateLoading = false
      }
    },

    resetPeriodGroupCloseParams() {
      this.periodGroupCloseCheck = []
      this.maxPeriodGroup = null
    },

    async updatePeriod(period) {
      try {
        this.saveBtnLoading = true
        await periodApi.update(period.getForAPI())
        this.clearDictionary(dictionaryNames.Period)
        await this.getDictionaries([dictionaryNames.Period])
        this.$toast.info('Успешно сохранено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    }
  },

  watch: {
    dataLoaded() {
      this.setTableHeight()
    },

    isShowTabs() {
      this.setTableHeight()
    },

    isShowFilter() {
      this.setTableHeight()
    },

    isShowSearch() {
      this.setTableHeight()
    },

    triggerSetTableHeight() {
      this.setTableHeight()
    }
  }
}
</script>

<style scoped>
.group-header {
  display: flex;
  align-items: center;
  justify-content: start;
  font-weight: 700 !important;
  cursor: pointer;
}
</style>
